import { Route } from 'react-router-dom';
import NotFound from './pages/NotFound';

export const NOT_FOUND_ROUTE = '/404';

export const NotFoundRoute = <Route path={NOT_FOUND_ROUTE} element={<NotFound />} />;
